<template>
  <div class="widget-wrapper" :class="{ loading: loading }">
    <b-dropdown v-if="menuOptions && !contentOnly" right class="ui-dashboard-menu-dropdown has-submenu" toggle-class="widget-dropdown-toggle" ref="widget-main-dropdown" id="widget-main-dropdown">
      <template #button-content>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16m-7 6h7" />
        </svg>
      </template>

      <template v-for="(option, index) in menuOptions">

        <!-- dropdown item -->
        <b-dropdown-item v-if="!option.separator && !option.submenu" :key="'wo_' + index" @click="emitEvent(option)" :disabled="option.disabled">
          <svg-icon v-if="option.icon" :icon="option.icon" />
          <span>{{ option.name }}</span>
        </b-dropdown-item>

        <!-- separator -->
        <b-dropdown-divider v-if="option.separator" :key="'wo_' + index" />

        <!-- submenu -->
        <b-dropdown-item 
          v-if="option.submenu && option.items"
          class="li-has-sumbenu"
          :key="'wo_' + index"
          @mouseover.native="onOver('wo_' + index)" @contextmenu.native="contextMenuHandler($event)"
          @mouseleave.native="onLeave('wo_' + index)"
        >
          <b-dropdown dropright menu-class="submenu" class="ui-dashboard-submenu-dropdown" :ref="'wo_' + index" :id="'wo_' + index">
            <template #button-content>
              <svg-icon v-if="option.icon" :icon="option.icon" />
              <span class="submenu-opener">{{ option.name }}</span>
            </template>
            <b-dropdown-item v-for="(subitem, subindex) in option.items" :key="'wo_sub_' + subindex" @click="emitEvent(subitem)" :disabled="subitem.disabled">
              <svg-icon v-if="subitem.icon" :icon="subitem.icon" />
              <span>{{ subitem.name }}</span>
            </b-dropdown-item>
          </b-dropdown>
        </b-dropdown-item>

      </template>

    </b-dropdown>

    
    <div class="content-wrap">
      <div class="header" :class="{ 'has-header': hasHeader }">
        <slot name="header" />
      </div>
      <overlay-scrollbars :options="{ scrollbars: { autoHide: 'leave' }, overflowBehavior: { y: 'scroll', x: 'scroll' } }">

        <router-link v-if="contentLinkTo !== false && !extLink" :to="contentLinkTo" class="content">
          <LoadingSpinner v-if="loading" />
          <slot name="content" />
        </router-link>

        <a v-else-if="contentLinkTo !== false && extLink" :href="contentLinkTo" class="content">
          <LoadingSpinner v-if="loading" />
          <slot name="content" />
        </a>

        <div v-else class="content">
          <LoadingSpinner v-if="loading" />
          <slot name="content" />
        </div>

      </overlay-scrollbars>
      <div class="actions" :class="{ 'has-actions': hasActions }">
        <slot name="actions" />
      </div>
    </div>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/dashboard/ui/LoadingSpinner"
import SvgIcon from "@/components/dashboard/ui/SvgIcon"
  export default {
    name: 'base-widget',
    components: {
      SvgIcon, LoadingSpinner
    },
    props: {
      loading: {
        type: Boolean,
        required: true
      },
      widgetOptions: {
        type: Array,
        default: () => []
      },
      overrideOptions: {
        type: Boolean,
        default: false
      },
      contentOnly: {
        type: Boolean,
        default: false
      },
      contentLinkTo: {
        type: [String, Boolean],
        default: false
      },
      extLink: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        showingSubmenu: false
      }
    },
    computed: {
      hasActions () {
        return !!this.$slots['actions']
      },
      hasHeader () {
        return !!this.$slots['header']
      },
      widgetDefaultOptions () {
        let options = []
        if (this.$parent.widget.noRemove) {
          options = [{ name: this.$gettext('Refresh data'), icon: 'icon-refresh', event: { name: 'refresh' } }]
        } else {
          options = [
            { name: this.$gettext('Remove from dashboard'), icon: 'icon-remove', event: { name: 'remove' } },
            { separator: true },
            { name: this.$gettext('Refresh data'), icon: 'icon-refresh', event: { name: 'refresh' } }
          ]
        }
        return options
      },
      menuOptions () {
        if (this.overrideOptions) {
          return this.widgetOptions
        } else {
          const returnOptions = []
          if(this.widgetOptions.length > 0) {
            returnOptions.push({ separator: true })
          }
          return this.widgetOptions.concat(returnOptions).concat(this.widgetDefaultOptions)
        }
      }
    },
    mounted () {
      this.$root.$on('bv::dropdown::show', bvEvent => {
        if(bvEvent.target === 'ul.dropdown-menu.submenu') {
          this.showingSubmenu = true
        }
      })
      this.$root.$on('bv::dropdown::hide', bvEvent => {
        if(bvEvent.componentId === 'widget-main-dropdown' && this.showingSubmenu) {
          bvEvent.preventDefault()
        }
        if(bvEvent.target.classList.contains('submenu')) {
          this.showingSubmenu = false
        }
      })

    },
    methods: {
      contextMenuHandler (e) {
        e.preventDefault()
      },
      emitEvent (data) {
        this.showingSubmenu = false // item clicked allowing to close all dropdowns
        switch (data.event.name) {
          case 'link':
            this.$router.push(data.event.link);
            break;
          case 'refresh':
            this.$emit('refresh-data')
            break;
          case 'set-config':
            this.$emit('set-config', data.event.config)
            break;
          case 'custom-remove':
            this.$emit('custom-remove')
            break;
          default:
            this.$emit('widget-event', { 'event': data.event.name })
            break;
        }
      },
      onOver(element) {
        this.showingSubmenu = true
        this.$refs[element][0].visible = true;
      },
      onLeave(element) {
        this.showingSubmenu = false
        this.$refs[element][0].visible = false;
      }
    }
  }
</script>
<style lang="scss">
  .os-host.os-host-overflow-y {
    padding-right: 7px;
  }
  .widget-wrapper {
    .ui-dashboard-menu-dropdown {
      position: absolute;
      top: 10px;
      right: 10px;
      width: 30px;
      height: 30px;
      background: transparent;
      cursor: pointer;
      color: $colorTextBase;
      border-radius: calc(#{$gridBorderRadius} / 2);
      transition: all 0.2s ease;
      display: flex;
      align-items: center;
      justify-content: center;
      svg { width: 20px; }
      z-index: 100;
      &:hover {
        color: $colorBrand;
        background: #e8f7f3;
      }
      .widget-dropdown-toggle {
        background: none;
        padding: 0;
        border: 0;
        color: $colorTextBase;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        border-radius: calc(#{$gridBorderRadius} / 2);
        &:hover, &:active {
          background: #e8f7f3 !important;
          color: $colorBrand !important;
        }
        &:after {
          display: none;
        }
      }
      &.show {
        z-index: 1000;
        .widget-dropdown-toggle {
          color: $colorBrand;
          background: #e8f7f3;
          border: none;
        }
      }
      &.has-submenu {
        .dropdown-menu {
          overflow: visible;
        }
        .li-has-sumbenu {
          margin-left: -10px;
          margin-right: -10px;
          padding-left: 9.5px;
          padding-right: 9.5px;
          > .dropdown-item {
            padding: 0px;
          }
          button {
            padding: 7.5px;
            align-items: center;
            span { width: 100%; text-align: left; }
            &:hover, &:active {
              background: #e8f7f3 !important;
              color: $colorBrand !important;
            }
          }
        }
      }
    }
    .ui-dashboard-submenu-dropdown {
      width: 100%;
      button {
        margin: 0;
        padding: 0;
        width: 100%;
        display: flex;
        background: none;
        border: 0;
        color: $colorTextBase;
        font-size: inherit;
      }
      &.show > .dropdown-toggle {
        background: none;
        color: inherit;
      }
    }
    .os-host {
      width: 100%;
      height: 100%;
    }
  }
</style>
<style lang="scss" scoped>
.widget-wrapper {
  width: 100%; height: 100%;
  transition: opacity 0.3s ease;
  overflow: hidden;
  .content-wrap { 
    height: 100%; 
    display: flex;
    flex-direction: column;
  }
  &.loading {
    // .content-wrap {
    //   opacity: 0;
    // }
  }
  
  .content-wrap { transition: opacity 0.3s ease; }
  a.content:hover { text-decoration: none; }
  .content {
    display: flex;
    flex-direction: row;
    flex: 1;
    padding: 1rem;
    height: 100%;
  }
  .header {
    display: flex;
    flex-direction: column;
    font-size: 16px;
    cursor: grab;
    transition: background-color 0.2s ease;
    &.has-header { padding: 0.5rem 1rem; border-bottom: 1px solid $colorBorderDash; }
    .title {
      font-family: DINNextLTPro-Medium, sans-serif;
      display: flex;
      align-items: center;
      height: 30px;
      .title-icon {
        margin-right: 8px;
        border-radius: $radiusSm;
        color: $colorBrand;
        background: lighten($colorBrand, 50%);
        width: 21px;
        height: 21px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        font-size: 14px;
        svg {
          width: 15px;
          height: 15px;
        }
        opacity: 0.8;
        
        display: none;
      }
        
    }
    .description {
      color: #0000007d;
      font-size: 14px;
    }
    a {
      line-height: 1;
      color: $colorBrand;
      &:hover {
        text-decoration: none;
      }
    }
  }
  .actions {
    display: flex;
    align-items: center;
    background: $tableHeadColorBg;
    font-size: 14px;
    justify-content: center;
    &.has-actions { 
      padding: 8px $gridGutter;
    }
    a {
      line-height: 1;
      color: $colorBrand;
      &:hover {
        text-decoration: none;
      }
    }
  }
}
</style>
